<ng-content></ng-content>


// WEBPACK FOOTER //
// ./src/app/components/animated-header/animated-header.component.html